import { iconBoxStyle } from "app/components/TextEditor/components/mentionSuggestion/components/MentionNodeView/helper";
import TicketTypeIcon from "app/components/TicketTypeIcon";
import React, { FC } from "react";

const TicketMentionNode: FC<{
  label: string;
  ticketTypeIcon: string;
}> = ({ label, ticketTypeIcon }) => {
  return (
    <div className="rounded bg-primary/20 p-0.5 cursor-default flex items-center gap-1 truncate max-w-[150px] border-[0.8px] hover:border-primary">
      <div className="flex items-center justify-center" style={iconBoxStyle}>
        <TicketTypeIcon iconName={ticketTypeIcon} size={16} />
      </div>
      <span className="truncate !m-0 text-sm font-regular text-black !leading-none">
        {label}
      </span>
    </div>
  );
};

export default TicketMentionNode;
